/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crazy_Still_Zebra_PetInputs */

const fr_crazy_still_zebra_pet = /** @type {(inputs: Crazy_Still_Zebra_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de base`)
};

/**

* @param {Crazy_Still_Zebra_PetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const crazy_still_zebra_pet = /** @type {((inputs?: Crazy_Still_Zebra_PetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crazy_Still_Zebra_PetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_crazy_still_zebra_pet(inputs)
});